export default "__VITE_ASSET__WPyRQ5bM__"